// siteConfig.js - Global Configuration for Flood & Fire Pros
// Centralized configuration for branding, navigation, and site-wide settings

export const siteConfig = {
  // Brand Identity
  brand: {
    name: "Flood & Fire Pros",
    tagline: "Inland Empire's #1 Restoration Network",
    description: "Connect with certified restoration professionals for water damage, fire damage, and emergency restoration services.",
    logo: {
      desktop: "/shield-logo.svg",
      mobile: "/shield-logo.svg",
      alt: "Flood & Fire Pros - Trust the Leader in Restoration",
      width: 180,
      height: 56
    }
  },

  // Color Palette - Updated to match provided configuration
  colors: {
    // Primary brand colors
    primary: '#ea5416',        // Brand orange
    primaryDark: '#d63e0a',    // Darker orange for hover
    secondary: '#1b3a57',      // Navy blue
    secondaryDark: '#0c2c47',  // Darker navy
    secondaryLight: '#2d5a87', // Lighter navy for gradients
    tertiary: '#f9fafb',       // Light gray background

    // Accent colors
    accent: '#facc15',         // Yellow for "PROS" text
    warning: '#dc2626',        // Red for emergency
    info: '#5bb3f0',           // Light blue for water icon

    // Footer hero gradient for CTA sections
    footerHeroGradient: 'linear-gradient(135deg, #2d5a87 0%, #1b3a57 100%)',

    // Neutral colors
    white: '#ffffff',
    black: '#000000',
    dark: '#1a1a1a',
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      350: '#b0b0b0',       // Hero subtitle gray
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827'
    }
  },

  // Typography
  fonts: {
    heading: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', 'Courier New', monospace"
  },

  // Navigation Structure
  navigation: {
    main: [
      {
        label: "Find Restoration Companies",
        href: "/find-contractors/",
        description: "Browse certified restoration professionals",
        featured: true
      },
      {
        label: "For Restoration Professionals",
        href: "/restoration-professionals/",
        description: "Join our professional network"
      },
      {
        label: "Resources",
        href: "/resources/",
        description: "Educational content and guides"
      }
    ],
    footer: [
      {
        title: "For Homeowners",
        links: [
          { label: "🚨 Request Service", href: "/request-service" },
          { label: "Find Restoration Pros", href: "/find-contractors/" },
          { label: "How It Works", href: "/how-it-works-homeowners/" },
          { label: "Resource Center", href: "/resources/" }
        ]
      },
      {
        title: "Services",
        links: [
          { label: "Water Damage Restoration", href: "/water-damage-restoration/" },
          { label: "Fire Damage Restoration", href: "/fire-damage-restoration/" },
          { label: "Mold Damage Restoration", href: "/mold-damage-restoration/" }
        ]
      },
      {
        title: "For Restoration Professionals",
        links: [
          { label: "For All Restoration Professionals", href: "/restoration-professionals/" },
          { label: "Join Network", href: "/join-network/" },
          { label: "Join Free", href: "/membership/" }
        ]
      }
    ]
  },

  // Contact Information
  contact: {
    phone: "Request Call Back",
    email: "support@flood-and-fire-pros.direct",
    hours: "24/7 Emergency Response Available",
    rating: {
      score: 5.0,
      platform: "Google",
      display: "★★★★★"
    }
  },

  // SEO Defaults
  seo: {
    defaultTitle: "Flood & Fire Pros - Premium Restoration Professionals",
    titleTemplate: "%s | Flood & Fire Pros",
    defaultDescription: "Connect with certified restoration professionals for water damage, fire damage, and emergency restoration services. Premium professionals, fast response times.",
    keywords: [
      "water damage restoration",
      "fire damage restoration",
      "mold remediation",
      "emergency restoration",
      "restoration professionals",
      "certified professionals"
    ],
    openGraph: {
      type: "website",
      locale: "en_US",
      url: "https://flood-and-fire-pros.direct",
      siteName: "Flood & Fire Pros",
      images: [
        {
          url: "/shield-logo.svg",
          width: 1200,
          height: 630,
          alt: "Flood & Fire Pros - Premium Restoration Professionals"
        }
      ]
    }
  },

  // Feature Flags
  features: {
    smartMatching: true,
    realTimeChat: true,
    contractorRatings: true,
    emergencyBooking: true,
    insuranceIntegration: true,
    mobileApp: false // Coming soon
  }
};
